import loadable from '@loadable/component';

export const DiscoverPage = loadable(/* #__LOADABLE__ */ () => import('./DiscoverPage'));
